import React, { useState, useEffect } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import SupplierFilter from './SupplierFilter';
import SupplierList from './SupplierList';
import { Page_Size } from '../../../../Components/helper';
import * as todoAction from './store/SupplierToDo.action';
import SupplerSetting from './supplierSetting';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';

function SupplerTodo() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const progressIndicator = 'supplier-todo';
  const reducers = useSelector((redState) => redState);
  const {
    SupplierTodoModule: {
      supplierTodoList,
      supplierFilterValues: {
        searchText,
        selected_Season,
        selected_Brand,
        selected_Supplier,
        selected_Category1,
        selected_Category2,
        selected_Category3,
        selected_Category4,
        selected_Status,
        pageIndex,
        pageSize,
        selected_Section,
        selectedBomFields,
        sortOrder,
        sortPropertyName,
      },
      supplierTodoTotalCount,
      supplierToDoSelectedIds,
    },
    UserDetails: { isSupplierLoggedIn },
    SystemMastersDetails: { subBrandAccess },
  } = reducers;
  const [selectedColumn, setSelectedColumn] = useState([]);
  const [state, setState] = useState({
    isLoading: false,
    hasMore: false,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    isExportLoading: false,
    isDownloadLoading: false,
    selectedCount: 0,
  });

  const callFn = async () => {
    let filterd = {};
    const obj = JSON.parse(localStorage.getItem('supplierTodoListFilter'));
    const columnHideShowStatus = localStorage.getItem('supplier_todo_column_options')
      ? JSON.parse(localStorage.getItem('supplier_todo_column_options'))
      : [...selectedColumn];
    setSelectedColumn(columnHideShowStatus);
    if (obj) {
      filterd = {
        seasons: obj.selected_Season,
        brand: obj.selected_Brand,
        supplier: obj.selected_Supplier,
        category1: obj.selected_Category1,
        category2: obj.selected_Category2,
        category3: obj.selected_Category3,
        category4: obj.selected_Category4,
        status: obj.selected_Status,
        module: obj.selected_Section,
        bomFields: obj.selectedBomFields,
        licensorId: obj.selectedLicensor,
        licenseId: obj.selectedLicense,
        likenessId: obj.selectedLikeness,
      };
      obj.pageIndex = 1;
      await dispatch(todoAction.filterSortData(obj));
    }
    const params = {
      pageSize,
      pageIndex: 1,
      type: progressIndicator,
      ...filterd,
    };
    setState((prevState) => ({ ...prevState, isLoading: true }));
    const res = await dispatch(todoAction.getSupplierTodoList(params));
    if (res) {
      setState((prevState) => ({
        ...prevState,
        hasMore: true,
        isLoading: false,
      }));
    }
  };

  useEffect(() => {
    callFn();
  }, [dispatch]);

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      await dispatch(systemMasterAction.getSubBrandAccess());
    };
    fetchSubBrandAccess();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state?.searchLoaded) {
        const params = {
          searchText,
          pageIndex: 1,
          pageSize: Page_Size,
          seasons: selected_Season,
          brand: selected_Brand,
          supplier: selected_Supplier,
          category1: selected_Category1,
          category2: selected_Category2,
          category3: selected_Category3,
          category4: selected_Category4,
          status: selected_Status,
          type: progressIndicator,
          module: selected_Section,
          bomFields: selectedBomFields,
        };
        await dispatch(todoAction.getSupplierTodoList(params));
        setState((searchEndState) => ({
          ...searchEndState,
          isLoading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [searchText, dispatch, state.searchLoaded]);

  useEffect(() => {
    if (supplierTodoTotalCount > supplierTodoList?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [supplierTodoList?.length, supplierTodoTotalCount]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      searchText,
      seasons: selected_Season,
      brand: selected_Brand,
      supplier: selected_Supplier,
      category1: selected_Category1,
      category2: selected_Category2,
      category3: selected_Category3,
      category4: selected_Category4,
      pageIndex: index,
      pageSize,
      totalRecords: supplierTodoTotalCount,
      status: selected_Status,
      isScrolled: true,
      type: progressIndicator,
      module: selected_Section,
      bomFields: selectedBomFields,
      sortOrder,
      sortPropertyName,
    };

    const obj = {
      pageIndex: index,
      pageSize,
    };
    setState((prevState) => ({ ...prevState, isLoading: true }));

    await dispatch(todoAction.filterSortData(obj));
    await dispatch(todoAction.getSupplierTodoList(params));
    setState((prevState) => ({ ...prevState, isLoading: false }));
  };

  const getCount = (selectedCnt) => {
    setState((prevState) => ({
      ...prevState,
      selectedCount: selectedCnt.length,
    }));
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      searchLoaded: true,
    }));
    const obj = {
      searchText: targetValue,
    };
    await dispatch(todoAction.filterSortData(obj));
  };
  const mappedArray = [
    { label: 'Supplier', display: 'supplier', value: 1 },
    { label: 'Brand', display: 'brand', value: 2 },
    ...(subBrandAccess ? [{ label: 'Sub Brand', display: 'subBrandId', value: 10 }] : []),
    { label: 'Season', display: 'seasonId', value: 3 },
    { label: 'Month', display: 'month', value: 4 },
    { label: 'Year', display: 'year', value: 5 },
    { label: 'Category 1', display: 'catOneId', value: 6 },
    { label: 'Category 2', display: 'catTwoId', value: 7 },
    { label: 'Category 3', display: 'catThreeId', value: 8 },
    { label: 'Category 4', display: 'catFourId', value: 9 },
  ];

  const handleSelectChange = (selected) => {
    localStorage.setItem('supplier_todo_column_options', JSON.stringify([...selected]));
    setSelectedColumn([...selected]);
  };
  useEffect(() => {
    return () => {
      const obj = {
        searchText: '',
      };
      dispatch(todoAction.filterSortData(obj));
    };
  }, [dispatch]);
  return (
    <div>
      <div>
        <div className="page-title-filter sticky">
          <div className="title-container d-flex align-items-center">
            <h4 className="title">{t('REPORTS.SUPPLIER_TO_DO')}</h4>
          </div>

          <div className="search-filter">
            {supplierToDoSelectedIds && supplierToDoSelectedIds?.length > 0 && (
              <span style={{ textTransform: 'none' }} className="d-none d-md-inline-block txt-selected-cnt">
                {supplierToDoSelectedIds?.length} {t('COSTING_TO_DO_LIST.RECORD_SELECTED')}
              </span>
            )}
            {supplierTodoTotalCount > 0 && (
              <span style={{ textTransform: 'none' }} className="d-none d-md-inline-block txt-selected-cnt">
                {supplierTodoTotalCount} {t('COSTING_TO_DO_LIST.TOTAL_RECORDS')}
              </span>
            )}
            <div className="mobile-multi-search">
              {/* title-search-container */}
              <div className="custom-multiselect w-200 ">
                <MultiSelect
                  name="attributes"
                  options={mappedArray}
                  className="custom-multiselect-PO"
                  value={selectedColumn}
                  labelledBy={t('PROGRESS_INDICATOR.SELECT_ATTRIBUTES')}
                  onChange={handleSelectChange}
                />
              </div>

              <SearchBar placeholder={t('PROGRESS_INDICATOR.SEARCH')} onSearch={handleSearch} value={searchText} />
            </div>

            <div className="mobile-btns">
              <SupplierFilter />
              {!isSupplierLoggedIn && <SupplerSetting callFn={callFn} />}
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-container">
        <span className="top" />
        <span className="left" />
        <span className="right" />
        <div className="all-scroll">
          <div
            id="scrollableDiv"
            style={{
              height: '100%',
              overflow: 'scroll',
            }}
          >
            <InfiniteScroll
              dataLength={supplierTodoList?.length}
              hasMore={state.hasMore}
              next={() => handlePageNextInScroll()}
              scrollableTarget="scrollableDiv"
              className="fixed-col-container"
            >
              <SupplierList
                loading={state.isLoading}
                getSelectedCount={getCount}
                selectedColumns={selectedColumn?.map((vl) => vl.label)}
                subBrandAccess={subBrandAccess}
              />
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplerTodo;
